// extracted by mini-css-extract-plugin
module.exports = {"search-wrap":"style_search-wrap__1c-ZW"};